import React from "react";
import { Button, Content } from "./styles";
export const PrintButton = ({
  children,
  className,
  onClick,
  url
}) => {
  const handleClick = () => {
    window.open(`/print${url}`, "_blank");
    onClick === null || onClick === void 0 || onClick();
  };
  return /*#__PURE__*/React.createElement(Button, {
    className: className,
    type: "button",
    onClick: handleClick,
    "data-qa": "print-button"
  }, /*#__PURE__*/React.createElement(Content, null, children));
};
PrintButton.displayName = "PrintButton";